import { Vue } from 'vue-property-decorator'

export const dispatchStatus = () => {
  return {
    SUCCESS: { key: 50610001, label: Vue.prototype.$gettext('DISPATCH_STATUS.50610001') },
    FAILED: { key: 50610002, label: Vue.prototype.$gettext('DISPATCH_STATUS.50610002') },
    BOUNCED: { key: 50610003, label: Vue.prototype.$gettext('DISPATCH_STATUS.50610003') },
    QUEUED: { key: 50610004, label: Vue.prototype.$gettext('DISPATCH_STATUS.50610004') },
    PROCESSING: { key: 50610005, label: Vue.prototype.$gettext('DISPATCH_STATUS.50610005') },
    NOT_SENT: { key: 50610006, label: Vue.prototype.$gettext('DISPATCH_STATUS.50610006') }
  }
}
